// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 58 ? "quill" : chunkId) + "." + {"58":"921ea5f4f7c99092","161":"2a03f5773fc10dfd"}[chunkId] + ".js";
};